<template>
  <div class="relative">
    <!-- هدر -->
    <div class="h-80 bg-bgheader absolute w-full"></div>

    <div class="absolute w-full">
      <!-- بخش جستجو -->
      <div class="flex flex-col justify-center">
        <h2 class="text-right text-base font-bold pt-10 mr-5 text-white">
          جستجوی مشتری
        </h2>
        <div class="w-full flex flex-col justify-center items-center gap-y-4">
          <div class="w-full flex flex-row justify-center text-white mt-8">
            <div
              v-for="item in customerTypes"
              :key="item.type"
              class="form-check form-check-inline mx-2"
            >
              <input
                class="form-check-input"
                type="radio"
                :id="item.type"
                :value="item.type"
                v-model="filtercustomer"
                @change="onCustomerTypeChange"
              />
              <label class="form-check-label mr-1" :for="item.type">
                {{ item.label }}
              </label>
            </div>
          </div>
          <div class="w-full flex justify-center items-center">
            <input
              type="text"
              v-model="valSearch"
              @input="validateInput"
              placeholder="کد ملی را وارد کنید"
              @keyup.enter="search"
              class="border text-center p-2 rounded-lg text-cyan-900 bg-white shadow-lg mt-2 w-4/5 ml-1"
            />
            <div
              class="flex justify-center py-1.5 px-2 mt-2 bg-bgbutton border border-yellow-500 rounded-xl shadow-md cursor-pointer"
              @click="search"
            >
              <font-awesome-icon
                icon="magnifying-glass"
                class="fa-xl text-bgfont mt-1"
              />
            </div>
          </div>
          <span
            v-if="inputSearch.error"
            class="text-red-700 font-bold text-base text-center px-2"
            >{{ inputSearch.error }}</span
          >
        </div>
      </div>

      <!-- فرم ثبت مشتری جدید (فقط وقتی نتیجه پیدا نشد) -->
      <div v-if="showForm" class="mt-6">
        <!-- فرم -->
        <form
          @submit.prevent="createCustomer"
          class="bg-white rounded-2xl px-4 py-6 border text-cyan-900 text-sm mt-2 mx-4 shadow-lg mb-20"
        >
          <!-- حقیقی یا اتباع -->
          <template
            v-if="this.lengthsValSearch === 10 || lengthsValSearch === 12"
          >
            <input
              class="input-style"
              type="text"
              placeholder="نام"
              v-model="customer.customerName"
            />
            <span v-if="inputName.error" class="error-text">{{
              inputName.error
            }}</span>

            <input
              class="input-style"
              type="text"
              placeholder="نام خانوادگی"
              v-model="customer.customerFamily"
            />
            <span v-if="inputFamily.error" class="error-text">{{
              inputFamily.error
            }}</span>

            <input
              class="input-style"
              type="tel"
              placeholder="کد ملی"
              v-model="customer.shO_MELI"
              disabled
            />
            <span v-if="inputCodeMelli.error" class="error-text">{{
              inputCodeMelli.error
            }}</span>

            <input
              class="input-style"
              type="tel"
              placeholder="کد پستی"
              v-model="customer.shO_POSTI"
            />
            <span v-if="inputCodePosti.error" class="error-text">{{
              inputCodePosti.error
            }}</span>

            <input
              class="input-style"
              type="tel"
              placeholder="موبایل"
              v-model="customer.mobile"
            />
            <span v-if="inputMobile.error" class="error-text">{{
              inputMobile.error
            }}</span>
          </template>

          <!-- حقوقی یا مشارکتی -->
          <template
            v-if="
              lengthsValSearch === 11 ||
              lengthsValSearch === 14 ||
              (lengthsValSearch === 12 && filtercustomer === 'legal')
            "
          >
            <input
              class="input-style"
              type="text"
              placeholder="نام شرکت"
              v-model="customer.sherkaT_N"
            />
            <span v-if="inputCompanyName.error" class="error-text">{{
              inputCompanyName.error
            }}</span>

            <input
              class="input-style"
              type="tel"
              placeholder="تلفن ۱"
              v-model="customer.tel1"
            />
            <span v-if="inputPhone.error" class="error-text">{{
              inputPhone.error
            }}</span>

            <input
              class="input-style"
              type="tel"
              placeholder="تلفن ۲"
              v-model="customer.tel2"
            />

            <input
              class="input-style"
              type="tel"
              placeholder="شماره اقتصادی"
              v-model="customer.shO_EGHTESADI"
            />
            <span v-if="inputEghtesadi.error" class="error-text">{{
              inputEghtesadi.error
            }}</span>
            <input
              class="input-style"
              type="tel"
              placeholder="شناسه ملی"
              v-model="customer.shO_MELI"
            />
            <span v-if="inputShenaseMelli.error" class="error-text">{{
              inputShenaseMelli.error
            }}</span>
            <input
              class="input-style"
              type="tel"
              placeholder="موبایل"
              v-model="customer.mobile"
            />
            <span v-if="inputMobile.error" class="error-text">{{
              inputMobile.error
            }}</span>
            <input
              class="input-style"
              type="tel"
              placeholder="کد پستی"
              v-model="customer.shO_POSTI"
            />
            <span v-if="inputCodePosti.error" class="error-text">{{
              inputCodePosti.error
            }}</span>
          </template>

          <!-- فیلد مشترک -->
          <input
            class="input-style h-24"
            type="text"
            placeholder="آدرس"
            v-model="customer.address"
          />
          <span v-if="inputAddress.error" class="error-text">{{
            inputAddress.error
          }}</span>

          <button
            class="flex justify-center bg-bgbutton py-2 rounded-lg shadow-lg w-full mt-4 mb-5 disabled:bg-gray-400 text-cyan-900 disabled:cursor-not-allowed"
            type="submit"
            :disabled="loading"
          >
            ثبت
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { postCustomer, getCustomer } from "../API/API";

export default {
  name: "AddCustomerPage",
  data() {
    return {
      valSearch: "",
      lengthsValSearch: "",
      showForm: false,
      filtercustomer: "",
      customerTypes: [
        { type: "real", label: "حقیقی" },
        { type: "legal", label: "حقوقی" },
        { type: "collaborative", label: "مشارکتی" },
        { type: "citizens", label: "اتباع" },
      ],
      inputName: { error: "" },
      inputFamily: { error: "" },
      inputCompanyName: { error: "" },
      inputCodeMelli: { error: "" },
      inputShenaseMelli: { error: "" },
      inputCodePosti: { error: "" },
      inputSearch: { error: "" },
      inputAddress: { error: "" },
      inputEghtesadi: { error: "" },
      inputPhone: { error: "" },
      inputMobile: { error: "" },
      customer: {
        customerName: "",
        customerFamily: "",
        sherkaT_N: "",
        tel1: "",
        tel2: "",
        mobile: "",
        shO_MELI: "",
        shO_POSTI: "",
        shO_EGHTESADI: "",
        address: "",
      },
      loading: false,
    };
  },
  methods: {
    onCustomerTypeChange() {
      this.valSearch = "";
      this.showForm = false;
      this.inputSearch.error = "";
      this.inputPhone.error = "";
      this.inputMobile.error = "";
      this.inputName.error = "";
      this.inputFamily.error = "";
      this.inputCompanyName.error = "";
      this.inputCodeMelli.error = "";
      this.inputShenaseMelli.error = "";
      this.inputCodePosti.error = "";
      this.inputAddress.error = "";
      this.inputEghtesadi.error = "";
      if (
        this.filtercustomer === "legal" ||
        this.filtercustomer === "collaborative"
      )
        this.customer.shO_MELI = "";
      else this.customer.shO_MELI = this.valSearch;
    },
    validateInput() {
      // فقط عدد قبول کنه
      this.valSearch = this.valSearch.replace(/[^0-9]/g, "");
    },
    validSearch() {
      this.inputSearch.error = "";
      if (this.filtercustomer === "real" && this.valSearch.length !== 10) {
        this.showForm = false;
        this.inputSearch.error = "کد ملی مشتری حقیقی 10 رقم است ";
      } else if (
        this.valSearch.length !== 12 &&
        this.filtercustomer === "citizens"
      ) {
        this.showForm = false;
        this.inputSearch.error = "کد ملی مشتری اتباع 12 رقم است ";
      } else if (
        (this.filtercustomer === "legal" ||
          this.filtercustomer === "collaborative") &&
        this.valSearch.length !== 11 &&
        this.valSearch.length !== 14
      ) {
        this.showForm = false;
        this.inputSearch.error =
          "شناسه ملی یا شماره اقتصادی مشتری حقوقی و مشارکتی باید 11 یا 14 رقم باشد";
      }
    },
    async search() {
      // بررسی انتخاب نوع مشتری
      if (!this.filtercustomer) {
        this.inputSearch.error = "لطفاً نوع مشتری را انتخاب کنید";
        return; // جلوگیری از ادامه عملیات جستجو
      }

      // بررسی مقدار ورودی جستجو
      if (!this.valSearch) {
        this.inputSearch.error = "لطفاً کد ملی یا شناسه را وارد کنید";
        return;
      }

      // پاک کردن خطا قبل از اعتبارسنجی
      this.inputSearch.error = "";

      // اعتبارسنجی
      this.validSearch();
      if (this.inputSearch.error) return;

      try {
        localStorage.removeItem("selectedCustomer");
        localStorage.removeItem("selectedAddress");
        localStorage.removeItem("selectedAddressId");

        const resp = await getCustomer(String(this.valSearch));
        if (resp.data && resp.data.result) {
          this.$swal({
            icon: "success",
            text: "مشتری وجود دارد",
            confirmButtonText: "رفتن به صفحه مشتری",
            confirmButtonColor: "#fcd34d",
            showCancelButton: false,
          }).then(() => {
            this.$router.push(`/customer`);
          });
        } else {
          this.customer.shO_MELI = this.valSearch;
          this.lengthsValSearch = this.valSearch.length;
          this.showForm = true;
        }
      } catch (err) {
        this.showForm = true;
      }
    },
    async createCustomer() {
      if (!this.ValidateForm()) return;
      try {
        this.loading = true;
        const resp = await postCustomer(this.customer);
        this.$swal({
          icon: "success",
          title: "موفق",
          text: "مشتری جدید با موفقیت ثبت شد",
          confirmButtonColor: "#fcd34d",
        }).then(() => {
          localStorage.setItem("selectedCustomer", resp.data.result.customerId);
          this.$router.push(`/address/${resp.data.result.customerId}`);
        });
      } catch (e) {
        this.$swal({
          icon: "error",
          title: "خطا",
          text: "ثبت مشتری با مشکل مواجه شد",
          confirmButtonColor: "#fcd34d",
        });
      } finally {
        this.loading = false;
      }
    },
    check(type, value) {
      this.filtercustomer = null;
      this.filtercustomerValue = null;
      this.filtercustomerValue = value;
      this.filtercustomer = type;
      this.inputPhone.error = "";
      this.inputMobile.error = "";
      this.inputName.error = "";
      this.inputFamily.error = "";
      this.inputCompanyName.error = "";
      this.inputCodeMelli.error = "";
      this.inputShenaseMelli.error = "";
      this.inputCodePosti.error = "";
      this.inputAddress.error = "";
      this.inputEghtesadi.error = "";
      this.customer.customerName = "";
      this.customer.customerFamily = "";
      this.customer.sherkaT_N = "";
      this.customer.tel1 = "";
      this.customer.tel2 = "";
      this.customer.mobile = "";
      this.customer.shO_MELI = "";
      this.customer.shO_POSTI = "";
      this.customer.shO_EGHTESADI = "";
      this.customer.isEnable = false;
      this.customer.address = "";
      this.customer.subarea = 0;
      this.customer.subareA_N = "";
      this.customer.personType = 0;
    },
    ValidateForm() {
      let result = true;
      this.inputPhone.error = "";
      this.inputMobile.error = "";
      this.inputName.error = "";
      this.inputFamily.error = "";
      this.inputCompanyName.error = "";
      this.inputCodeMelli.error = "";
      this.inputShenaseMelli.error = "";
      this.inputCodePosti.error = "";
      this.inputAddress.error = "";
      this.inputEghtesadi.error = "";

      if (this.filtercustomer == "real" || this.filtercustomer == "citizens") {
        if (!this.customer.customerName) {
          this.inputName.error = "لطفا نام مشتری را وارد کنید";
          result = false;
        }
        if (!this.customer.customerFamily) {
          this.inputFamily.error = "لطفا نام خانوادگی مشتری را وارد کنید";
          result = false;
        }
        if (!this.customer.shO_MELI) {
          this.inputCodeMelli.error = "لطفا کدملی خود را وارد کنید";
          result = false;
        } else if (
          this.customer.shO_MELI.length !== 10 &&
          this.filtercustomer == "real"
        ) {
          this.inputCodeMelli.error = "کدملی باید 10 رقم باشد";
          result = false;
        } else if (
          this.customer.shO_MELI.length !== 12 &&
          this.filtercustomer == "citizens"
        ) {
          this.inputCodeMelli.error = "کدملی باید 12 رقم باشد";
          result = false;
        }

        if (!this.customer.shO_POSTI) {
          this.inputCodePosti.error = "لطفا کدپستی مشتری را وارد کنید";
          result = false;
        } else if (this.customer.shO_POSTI.length !== 10) {
          this.inputCodePosti.error = " کدپستی باید 10 رقم باشد";

          result = false;
        }
        if (!this.customer.mobile) {
          this.inputMobile.error = "لطفا شماره مشتری را وارد کنید";
          result = false;
        } else if (this.customer.mobile.length !== 11) {
          this.inputMobile.error = "شماره همراه باید 11 رقم باشد";

          result = false;
        } else if (this.customer.mobile.substr(0, 2) !== "09") {
          this.inputMobile.error = "شماره همراه باید با 09 شروع شود";

          result = false;
        }
      } else if (
        this.filtercustomer == "legal" ||
        this.filtercustomer == "collaborative"
      ) {
        if (!this.customer.tel1) {
          this.inputPhone.error = "لطفا شماره مشتری را وارد کنید";
          result = false;
        }
        if (!this.customer.shO_POSTI) {
          this.inputCodePosti.error = "لطفا کدپستی مشتری را وارد کنید";
          result = false;
        } else if (this.customer.shO_POSTI.length !== 10) {
          this.inputCodePosti.error = " کدپستی باید 10 رقم باشد";

          result = false;
        }

        if (!this.customer.sherkaT_N) {
          this.inputCompanyName.error = "لطفا نام شرکت را وارد کنید";
          result = false;
        }
        if (!this.customer.shO_EGHTESADI) {
          this.inputEghtesadi.error = "لطفا  شماره اقتصادی را وارد کنید";
          result = false;
        } else if (
          this.filtercustomer === "collaborative" &&
          this.customer.shO_EGHTESADI.length !== 11 &&
          this.customer.shO_EGHTESADI.length !== 14
        ) {
          this.inputEghtesadi.error = "شماره اقتصادی باید 11 یا 14 رقم باشد";
          result = false;
        } else if (
          this.filtercustomer === "legal" &&
          this.customer.shO_EGHTESADI.length !== 11 &&
          this.customer.shO_EGHTESADI.length !== 14
        ) {
          this.inputEghtesadi.error = "شماره اقتصادی باید 11 یا 14 رقم باشد";
          result = false;
        }

        if (!this.customer.shO_MELI) {
          this.inputShenaseMelli.error = "لطفا  شناسه ملی را وارد کنید";
          result = false;
        } else if (this.customer.shO_MELI.length !== 11) {
          this.inputShenaseMelli.error = "شناسه ملی باید 11 رقم باشد ";
          result = false;
        }
      }
      if (!this.customer.address) {
        this.inputAddress.error = "لطفا آدرس  را وارد کنید";
        result = false;
      }
      return result;
    },
  },
};
</script>

<style scoped>
.input-style {
  @apply border p-2 text-center rounded-lg text-black w-full mt-2 border-gray-300 disabled:bg-gray-300 disabled:cursor-none;
}
.error-text {
  @apply text-xs text-red-500;
}
</style>
